<template>
  <div
    :class="`name-${name}`"
    class="icon-container"
  >
    <template v-if="name === 'ChevronIcon'">
      <svg
        id="Layer_1"
        version="1.1"
        class="icon"
        xmlns:cc="http://creativecommons.org/ns#"
        xmlns:dc="http://purl.org/dc/elements/1.1/"
        xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 100 100"
        style="enable-background:new 0 0 100 100;"
        xml:space="preserve"
      >
        <g>
          <g transform="translate(50 50) scale(0.69 0.69) rotate(0) translate(-50 -50)">
            <path
              shape-rendering="auto"
              color-rendering="auto"
              image-rendering="auto"
              class="st0"
              d="M12.463,28.116
            c-1.726,0-3.125,1.4-3.125,3.126c0,0.843,0.341,1.651,0.946,2.239l37.5,37.5c1.22,1.22,3.199,1.22,4.419,0l37.5-37.5
            c1.243-1.197,1.281-3.176,0.084-4.419c-1.197-1.243-3.176-1.281-4.419-0.084c-0.028,0.027-0.056,0.055-0.084,0.084L49.994,64.352
            L14.703,29.062C14.115,28.457,13.307,28.116,12.463,28.116L12.463,28.116z"
            />
          </g>
        </g>
      </svg>
    </template>

    <template v-if="name === 'PreviousNotesIcon'">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="100"
        height="100"
        viewBox="0 0 100 100"
      >
        <g>
          <g
            transform="translate(50 50) scale(0.69 0.69) rotate(0) translate(-50 -50)"
            style="fill:#1A1A1A"
          ><svg
            fill="#1A1A1A"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            version="1.1"
            x="0px"
            y="0px"
            viewBox="0 0 100 100"
            enable-background="new 0 0 100 100"
            xml:space="preserve"
          >
            <path d="M82.914,31.086l-21-21C61.539,9.711,61.03,9.5,60.5,9.5h-36c-4.363,0-9,2.453-9,7v68c0,4.373,4.626,9,9,9h52  c4.547,0,7-4.637,7-9v-52C83.5,31.97,83.289,31.461,82.914,31.086z M61.5,15.328L77.672,31.5H66.5c-2.196,0-5-2.804-5-5V15.328z   M79.5,84.5c0,2.016-0.953,5-3,5h-52c-2.196,0-5-2.805-5-5v-68c0-2.047,2.983-3,5-3h33v13c0,4.374,4.626,9,9,9h13V84.5z   M60.094,57.354c-3.475-3.475-7.397-8.288-10.739-13.187c0.761-3.854,1.146-6.769,1.146-8.667c0-8.535-10-8.535-10,0  c0,1.673,1.547,4.869,4.602,9.506c-1.264,6.009-3.182,13.174-5.119,19.121c-4.354,1.906-7.344,3.656-8.896,5.209  c-1.995,1.994-2.6,4.602-1.617,6.973c0.887,2.141,2.902,3.578,5.016,3.578c1.28,0,2.467-0.51,3.43-1.473  c0.552-0.553,2.198-2.197,5.295-11.313c5.313-2.199,11.443-4.177,15.718-5.324c3.866,3.555,7.005,5.285,9.573,5.285  c2.91,0,5.277-2.182,5.277-4.865c0-1.66-0.951-3.173-2.609-4.152c-1.595-0.942-3.838-1.42-6.668-1.42  C63.608,56.625,62.129,56.87,60.094,57.354z M35.086,75.586c-0.27,0.27-0.473,0.301-0.602,0.301c-0.423,0-1.032-0.414-1.32-1.109  c-0.249-0.6-0.321-1.541,0.75-2.613c0.503-0.502,1.65-1.416,4.207-2.734C36.719,73.084,35.672,75,35.086,75.586z M44.5,35.5  c0-1.745,0.662-2.5,1-2.5s1,0.755,1,2.5c0,0.874-0.113,2.106-0.33,3.619C44.921,36.914,44.53,35.79,44.5,35.5z M44.79,62.171  c1.248-4.106,2.443-8.553,3.416-12.706c2.415,3.288,5.006,6.435,7.468,9.068C52.526,59.447,48.655,60.7,44.79,62.171z   M69.777,62.197c0,0.345-0.51,0.865-1.277,0.865c-0.566,0-1.993-0.278-4.689-2.375c0.311-0.043,0.539-0.063,0.689-0.063  c2.76,0,4.088,0.541,4.634,0.864C69.531,61.724,69.777,61.995,69.777,62.197z" />
          </svg></g>
        </g>
      </svg>
    </template>
    <template v-if="name === 'WineMakingIcon'">
      <svg
        version="1.1"
        class="icon"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 100 100"
        style="enable-background:new 0 0 100 100;"
        xml:space="preserve"
      >
        <g>
          <path
            class="st0"
            d="M36.713,77.166c-5.364,0-9.728-4.364-9.728-9.73s4.364-9.73,9.728-9.73s9.728,4.364,9.728,9.73
          S42.077,77.166,36.713,77.166z M36.713,61.43c-3.311,0-6.006,2.695-6.006,6.008s2.695,6.008,6.006,6.008s6.006-2.695,6.006-6.008
          S40.024,61.43,36.713,61.43z"
          />
          <path
            class="st0"
            d="M52.632,64.322c-5.364,0-9.728-4.364-9.728-9.73c0-5.364,4.364-9.728,9.728-9.728
          c5.366,0,9.73,4.364,9.73,9.728C62.362,59.959,57.997,64.322,52.632,64.322z M52.632,48.588c-3.311,0-6.006,2.693-6.006,6.006
          s2.695,6.008,6.006,6.008s6.008-2.695,6.008-6.008S55.943,48.588,52.632,48.588z"
          />
          <path
            class="st0"
            d="M68.55,51.476c-5.366,0-9.73-4.364-9.73-9.728s4.364-9.728,9.73-9.728s9.73,4.364,9.73,9.728
          S73.916,51.476,68.55,51.476z M68.55,35.742c-3.311,0-6.008,2.695-6.008,6.006s2.695,6.006,6.008,6.006
          c3.313,0,6.008-2.695,6.008-6.006C74.558,38.437,71.861,35.742,68.55,35.742z"
          />
          <path
            class="st0"
            d="M57.074,86.115c-5.364,0-9.728-4.364-9.728-9.73c0-5.364,4.364-9.728,9.728-9.728
          c5.366,0,9.73,4.364,9.73,9.728C66.803,81.752,62.44,86.115,57.074,86.115z M57.074,70.38c-3.311,0-6.006,2.693-6.006,6.006
          s2.693,6.008,6.006,6.008s6.008-2.695,6.008-6.008S60.385,70.38,57.074,70.38z"
          />
          <path
            class="st0"
            d="M73,73.269L73,73.269c-0.622,0-1.249-0.06-1.863-0.181c-5.263-1.022-8.716-6.138-7.696-11.403
          c0.882-4.562,4.893-7.873,9.535-7.873c0.623,0,1.254,0.061,1.87,0.182c2.548,0.493,4.753,1.951,6.207,4.106
          c1.455,2.153,1.982,4.744,1.487,7.294C81.655,69.958,77.644,73.269,73,73.269z M72.978,57.534c-2.862,0-5.336,2.044-5.881,4.86
          c-0.629,3.251,1.504,6.408,4.752,7.041c3.216,0.631,6.419-1.554,7.041-4.752c0.305-1.575-0.02-3.173-0.918-4.504
          c-0.897-1.329-2.259-2.228-3.834-2.533C73.752,57.571,73.363,57.534,72.978,57.534z"
          />
          <path
            class="st0"
            d="M77.119,94.667c-5.364,0-9.728-4.363-9.728-9.727s4.364-9.728,9.728-9.728s9.727,4.364,9.727,9.728
          S82.483,94.667,77.119,94.667z M77.119,78.936c-3.311,0-6.006,2.693-6.006,6.006c0,3.309,2.693,6.004,6.006,6.004
          c3.309,0,6.004-2.693,6.004-6.004C83.123,81.629,80.43,78.936,77.119,78.936z"
          />
          <path
            class="st0"
            d="M46.294,39.672L46.294,39.672c-0.409,0-0.849-0.145-1.184-0.395v0.002c-0.302-0.231-7.387-5.716-6.739-14.013
          c0.553-7.063,6.501-13.696,17.681-19.712c0.597-0.322,1.331-0.292,1.9,0.082c0.573,0.374,0.892,1.031,0.834,1.712
          c-0.006,0.078-0.631,7.908,1.353,15.68c0.778,3.047,0.015,6.172-2.211,9.034C54.34,36.683,47.767,39.672,46.294,39.672z
          M54.962,10.456c-8.048,4.847-12.483,10.034-12.879,15.102c-0.389,4.986,3.116,8.798,4.618,10.186
          c1.878-0.765,6.745-3.313,8.952-6.918c1.009-1.649,1.297-3.246,0.882-4.878C55.213,18.769,54.956,13.679,54.962,10.456z"
          />
          <path
            class="st0"
            d="M43.765,46.496c-0.547,0-1.089-0.24-1.457-0.702c-12.284-15.418-26.304-8.487-26.444-8.413
          c-0.918,0.465-2.038,0.106-2.505-0.808c-0.467-0.916-0.108-2.036,0.808-2.505c0.168-0.084,16.89-8.366,31.052,9.406
          c0.64,0.804,0.508,1.975-0.296,2.615C44.582,46.363,44.173,46.496,43.765,46.496z"
          />
        </g>
      </svg>
    </template>

    <template v-if="name === 'TastingNotesIcon'">

      <svg
        version="1.1"
        class="icon"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 100 100"
        style="enable-background:new 0 0 100 100;"
        xml:space="preserve"
      >

        <path
          class="st0"
          d="M75.789,11.355c-0.532-1.899-1.063-3.684-1.5-5.488c-0.214-0.868-1.005-1.469-1.899-1.443H27.458
        c-0.894-0.026-1.685,0.575-1.899,1.443c-0.437,1.728-0.912,3.456-1.386,5.184c-2.792,10.027-5.697,20.377,0.646,30.499
        c5.054,8.183,13.728,13.445,23.32,14.148v36.082H36.745c-1.049,0-1.899,0.85-1.899,1.899c0,1.049,0.85,1.899,1.899,1.899h26.587
        c1.049,0,1.899-0.85,1.899-1.899c0-1.049-0.85-1.899-1.899-1.899H51.937V55.698c11.364-0.76,21.282-7.976,25.504-18.554
        C80.669,28.408,78.182,19.749,75.789,11.355z M27.895,12.02c0.361-1.291,0.722-2.564,1.044-3.798h41.988
        c0.361,1.386,0.76,2.773,1.177,4.178c1.195,3.828,2.109,7.737,2.735,11.698c-6.933,3.358-15.151,2.628-21.383-1.899
        c-10.768-7.14-23.073-0.437-28.486,3.323C25.526,20.94,26.505,16.42,27.895,12.02z M73.89,35.739
        c-3.99,9.683-13.38,16.045-23.852,16.161c-8.922-0.106-17.17-4.771-21.858-12.363c-1.748-2.794-2.802-5.964-3.076-9.248
        c2.146-1.766,15.591-11.983,26.302-4.975c6.924,4.928,15.889,5.967,23.757,2.754C75.211,30.68,74.779,33.28,73.89,35.739z"
        />
      </svg>

    </template>
    <template v-if="name === 'TecnicalNotesIcon'">
      <svg
        version="1.1"
        class="icon"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 100 100"
        style="enable-background:new 0 0 100 100;"
        xml:space="preserve"
      >
        <g transform="translate(0,-952.36218)">
          <path
            class="st0"
            d="M22.5,958.362c-3.289,0-6,2.711-6,6v76c0,3.289,2.711,6,6,6h2.875H78.5c2.289,0,5-2.711,5-6v-76
          c0-3.289-2.711-6-6-6h-0.25H25.875L22.5,958.362L22.5,958.362z M22.5,962.362h5v80h-3.875H22.5c-1.143,0-2-0.857-2-2v-76
          C20.5,963.22,21.357,962.362,22.5,962.362z M31.5,962.362h22v27c0,1.105,0.896,2,2,2c0.339,0,0.672-0.086,0.968-0.25l6.031-4.469
          l6.031,4.469c0.967,0.535,2.184,0.185,2.719-0.781c0.164-0.296,0.25-0.63,0.25-0.969v-27h6c1.143,0,2,0.857,2,2v76
          c0,1.143-0.857,2-2,2h-46L31.5,962.362L31.5,962.362z M57.5,962.362h10v23.594l-4.031-3.344c-0.603-0.334-1.335-0.334-1.938,0
          l-4.031,3.344V962.362z"
          />
        </g>
      </svg>
    </template>

  </div>
</template>

<script>
export default {
  name: 'product-details-svg-icons',
  props: {
    name: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.icon-container {
  display: flex;
}
</style>
